import React from 'react';
import Features from 'components/Features';
import { t } from '@lingui/macro';
import { i18n } from '@lingui/core';

import { Container, Section, SectionTitle } from 'components';
import { ColorVariants } from 'theme';

type FeaturesType = {
    icon: React.FC<{}>;
    name: string;
    description: string;
};

type FeaturesList = Array<FeaturesType>;

export default ({
    title = i18n._(t`The benefits of Premium+`),
    showTitle = true,
    background,
    featuresTextColor,
    featuresPictorialColor = 'brand',
    featuresList,
}: {
    title?: string;
    showTitle?: boolean;
    background?: ColorVariants;
    featuresTextColor?: ColorVariants;
    featuresPictorialColor?: ColorVariants;
    featuresList: FeaturesList;
}) => {
    return (
        <Section background={background ? background : 'toast'}>
            <Container>
                {showTitle ? (
                    <SectionTitle align="center" title={title} />
                ) : null}

                <Features
                    textColor={featuresTextColor}
                    pictorialColor={featuresPictorialColor}
                    features={featuresList}
                />
            </Container>
        </Section>
    );
};
